import React from 'react';

import { UiButton } from '../ui/ui-button';
import { UiDialog } from '../ui/ui-dialog';

type InputProps = {
  onClose: () => void;
  name: string;
};

export const CreateUserSuccessDialog = ({ name, onClose }: InputProps) => (
  <UiDialog onClose={onClose} size="xs" title="Successfully Added User">
    <UiDialog.Content>
      <div className="u-textAlign-center typo-title">
        Great! We&apos;ve sent {name} an email with instructions on how to get started.
      </div>
    </UiDialog.Content>
    <UiDialog.Actions>
      <UiButton onClick={onClose}>Done</UiButton>
    </UiDialog.Actions>
  </UiDialog>
);
